module.exports = "<div class=\"text-center gw-carousel__slide\" ng-transclude ng-class=\"{'gw-carousel__slide_active' : active === true}\"></div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/carousel/ui-bootstrap-carousel/templates/slide.html
// module id = 954
// module chunks = 0